import {
  WSDivider,
  WSList,
  WSListProps,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import { openInNewTab } from "../../utils/openInNewTab";
import React from "react";
import styles from "./styles.module.scss";

export type FAQItem = { label: string; url?: string; onClick?(): void };

export type FAQSection = {
  title: string;
  links: FAQItem[];
};

export type FAQProps = {
  title?: string;
  sections: FAQSection[];
} & WSListProps;

const link = (url: string) => () => {
  openInNewTab(url);
};

const Link: React.FC<FAQItem> = ({ url, label, onClick }) => (
  <WSText.ParagraphXs
    color="blue400"
    weight="medium"
    className={styles.link}
    onClick={onClick ? onClick : url ? link(url) : undefined}
  >
    {label}
  </WSText.ParagraphXs>
);

export const FAQ: React.FC<FAQProps> = ({
  sections,
  title = "Frequently asked questions",
  ...props
}) => {
  return (
    <WSList gap="XL" {...props}>
      {title && <WSText.Paragraph weight="medium">{title}</WSText.Paragraph>}
      <WSPanel p="XL" colorBackground="gray50" noBorder>
        <WSList gap="2XL">
          {sections.map((section, index) => (
            <WSList gap="M" key={section.title + index}>
              <WSText.ParagraphSm color="gray400">
                {section.title}
              </WSText.ParagraphSm>
              <WSDivider />

              {section.links.map((link, index) => (
                <Link key={section.title + index} {...link} />
              ))}
            </WSList>
          ))}
        </WSList>
      </WSPanel>
    </WSList>
  );
};
